<template>
    <div>
        <Sidebar></Sidebar>
        <ExemptionExtendDeadline
            :show-modal.sync="extendModal.showModal"
            :exemption="extendModal.chosenExemption"
            :enterprise-sector="extendModal.chosenExemption && extendModal.chosenExemption.enterprise && extendModal.chosenExemption.enterprise.sector"
            @extendSuccess="handleExtendSuccess"
        ></ExemptionExtendDeadline>
        <ExemptionEvaluation :modalTitle="'Ne pas poursuivre et archiver la demande'"
                             :fieldName="'Motif d\'abandon'"
                             :isAbort="true"
                             :showModal.sync="modal.showModal"
                             :exemption.sync="modal.chosenExemption"
                             v-on:abortSuccess="handleSuccessAbort"
        ></ExemptionEvaluation>

        <div class="content-wrapper content-wrapper-exemption">
            <div class="img-desktop img-desktop-list d-lg-inline-block"></div>
            <Header></Header>

            <section class="content table-content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="request-title list-title">
                            <h1>Gérer les dispenses</h1>
                        </div>
                    </div>
                    <div>
                        <vuetable ref="vuetable"
                            :fields="fields"
                            :api-mode="false"
                            :data="exemptions"
                            no-data-template="Aucune donnée disponible"
                            class="table table-striped table-bordered"
                        >
                            <div slot="status" slot-scope="props">
                                <div v-if="props.rowData.status === 'to_finalise'">
                                    <i class="far fa-clock"></i><span class="ml-2">{{ getExemptionStatusLabel('to_finalise') }}</span>
                                </div>
                                <div v-else-if="props.rowData.status === 'to_validate'">
                                    <i class="fas fa-check"></i><span class="ml-2">{{ getExemptionStatusLabel('to_validate') }}</span>
                                </div>
                                <div v-else-if="props.rowData.status === 'to_renew'">
                                    <i class="fas fa-sync-alt"></i><span class="ml-2">{{ getExemptionStatusLabel('to_renew') }}</span>
                                </div>
                                <div v-else-if="props.rowData.status === 'to_abort'">
                                    <i class="fas fa-trash"></i><span class="ml-2">{{ getExemptionStatusLabel('to_abort') }}</span>
                                </div>
                                <div v-else-if="props.rowData.status === 'renewal_declined'">
                                    <i class="fas fa-times-circle"></i><span class="ml-2">{{ getExemptionStatusLabel('renewal_declined') }}</span>
                                </div>
                                <div v-else-if="props.rowData.status === 'draft'">
                                    <i class="fa fa-edit"></i><span class="ml-2">{{ getExemptionStatusLabel('draft') }}</span>
                                </div>
                            </div>

                            <div
                                slot="date"
                                slot-scope="props"
                                :class="getDeadlineDateClass(props.rowData.deadlineDate)">
                                <template v-if="props.rowData.status !== 'to_abort'">
                                    {{ props.rowData.deadlineDate | formatDate }}
                                </template>
                            </div>

                            <div slot="fullName" slot-scope="props">
                                {{ props.rowData.civility }} {{ props.rowData.firstName }} {{ props.rowData.lastName }}
                            </div>

                            <div slot="startDate" slot-scope="props">
                                {{ props.rowData.startDate | formatDate }}
                            </div>

                            <div slot="expirationDate" slot-scope="props">
                                <template v-if="props.rowData.exemptionReason">
                                    {{ props.rowData.exemptionReason.expirationDate | formatDate }}
                                </template>
                            </div>

                            <div slot="reason" slot-scope="props">
                                <div v-if="props.rowData.exemptionReason">
                                    {{ props.rowData.exemptionReason.reason.titleHroShort }}
                                </div>
                                <div v-else>
                                    Laisser le choix au salarié
                                </div>
                            </div>

                            <div slot="actions" slot-scope="props">
                                <select name="row-1-exemption"
                                        class="custom-select"
                                        v-model="selectValue"
                                        @change="handleSelect($event, props.rowData)"
                                >
                                    <option disabled selected value="default">Action</option>
                                    <option v-if="props.rowData.status === 'to_validate' && isCanCreateExemptions"
                                            value="validate"
                                    >Valider ou refuser la demande</option>
                                    <option v-if="props.rowData.status === 'to_validate' && isCanEditExemptions"
                                            value="abort"
                                    >Ne pas poursuivre et archiver cette demande</option>
                                    <option v-if="(props.rowData.status === 'to_finalise' || props.rowData.status === 'draft') && isCanEditExemptions"
                                            value="edit"
                                    >Compléter la demande</option>
                                    <option v-if="props.rowData.status === 'to_finalise'"
                                            value="resendEmail"
                                    >Relancer</option>
                                    <option v-if="isDeadlineExpired(props.rowData.deadlineDate) && isCanExtendExemptions"
                                            value="extendDeadline"
                                    >Repousser la date limite</option>
                                    <option v-if="props.rowData.status === 'to_finalise' && isCanEditExemptions"
                                            value="abort"
                                    >Ne pas poursuivre et archiver cette demande</option>
                                    <option v-if="props.rowData.status === 'to_renew' && isCanCreateExemptions"
                                            value="renew"
                                    >Renouveler</option>
                                    <option v-if="props.rowData.status === 'to_renew' && isCanEditExemptions"
                                            value="abort"
                                    >Ne pas poursuivre et archiver cette demande</option>
                                    <option v-if="props.rowData.status === 'to_abort' && isCanEditExemptions"
                                            value="abort"
                                    >Valider l’abandon de cette demande</option>
                                </select>
                            </div>
                        </vuetable>

                        <Paginator :items.sync="exemptions"
                                   :pagination.sync="pagination"
                                   class="float-right"
                        ></Paginator>
                    </div>
                </div>
            </section>
        </div>

        <Footer></Footer>
    </div>
</template>

<script>
    import Sidebar from '../../components/Sidebar';
    import Footer from '../../components/Footer';
    import Vuetable from 'vuetable-2';
    import Paginator from '../../components/Paginator';
    import ExemptionEvaluation from '../../components/modal/ExemptionEvaluation';
    import Header from '../../components/Header';
    import ExemptionListTableFields from './exemptionListTableFields';
    import { formatDate } from '@/utils/filters';
    import { getExemptionStatusLabel } from '@/utils/utils';
    import { successMessage, errorMessage, messageTexts } from '@/utils/sweet-alert-options';
    import permissionManager from '../../service/manager/permissionManager';
    import ExemptionExtendDeadline from '../../components/modal/ExemptionExtendDeadline';
    import {
        fetchRequestedExemptions,
        resendEmployeeExemptionUpdateEmail,
    } from '@/service/api/exemptions.api';
    import { mapGetters } from "vuex";
    import { dateFromStringSameOrBeforeNowConstraint } from '@/utils/validation';
    export default {
        data() {
            return {
                exemptions: [],
                pagination: {
                    currentPage: 1,
                    totalItems: null,
                    itemsPerPage: 10
                },
                modal: {
                    showModal: false,
                    chosenExemption: null
                },
                extendModal: {
                    showModal: false,
                    chosenExemption: null,
                },
                selectValue: 'default',
            };
        },
        computed: {
            page() {
                return this.pagination.currentPage;
            },
            fields() {
                if (this.enterpriseSettings?.employeeNumberHandled) {
                    return ExemptionListTableFields;
                }

                return ExemptionListTableFields.filter(({ name }) => name !== 'employeeNumber');
            },
            ...mapGetters({
                userPermissions: 'userPermissions',
                enterpriseUuid: 'enterpriseUuid',
                enterpriseSettings: 'enterpriseSettings',
            }),
            isCanCreateExemptions() {
                return permissionManager.isCanCreateExemptions(this.userPermissions);
            },
            isCanEditExemptions() {
                return permissionManager.isCanEditExemptions(this.userPermissions);
            },
            isCanExtendExemptions() {
                return permissionManager.isCanExtendExemptions(this.userPermissions);
            },
        },
        watch: {
            page() {
                this.fetchExemptions();
            },
        },
        created() {
            this.fetchExemptions();
            this.enterpriseUuid && this.$store.dispatch('setSettingsContext', { enterpriseUuid: this.enterpriseUuid });
        },
        methods: {
            getExemptionStatusLabel,
            async fetchExemptions() {
                const status = this.$route.query.status;
                const { data } = await fetchRequestedExemptions(this.pagination, status);
                this.exemptions = data.items;
                this.pagination.totalItems = data.totalItems;
                this.$refs.vuetable && this.$refs.vuetable.setData(this.exemptions);
            },
            async resendEmail(exemption) {
                try {
                    await resendEmployeeExemptionUpdateEmail(exemption.id);
                    await this.fetchExemptions();
                    this.$swal({ title: messageTexts.resendEmailSuccess, ...successMessage });
                } catch ({ response }) {
                    this.$swal({ title: messageTexts.resendEmailError, ...errorMessage });
                }
            },
            handleSelect(event, exemption) {
                this.selectValue = 'default';
                switch (event.target.value) {
                    case 'abort':
                        this.showAbortExemptionModal(exemption);
                        break;
                    case 'validate':
                        this.$router.push({ name: 'exemption-appreciation', params: { id: exemption.id } });
                        break;
                    case 'edit':
                        this.$router.push({ name: 'exemption-edit', params: { exemptionId: exemption.id }});
                        break;
                    case 'renew':
                        this.$router.push({ name: 'exemption-renew', params: { exemptionId: exemption.id }});
                        break;
                    case 'resendEmail':
                        this.resendEmail(exemption);
                        break;
                    case 'extendDeadline':
                        this.showExtendDeadlineModal(exemption);
                        break;
                }
            },
            showAbortExemptionModal(exemption) {
                window.scrollTo({ top: 0, left: 0, behaviour: 'smooth' });
                this.modal.chosenExemption = exemption;
                this.modal.showModal = true;
            },
            handleSuccessAbort() {
                this.fetchExemptions();
                this.$swal({ title: messageTexts.abortSuccess, ...successMessage });
            },
            getDeadlineDateClass(date) {
                return dateFromStringSameOrBeforeNowConstraint(date) ? 'color-red' : null;
            },
            isDeadlineExpired(date) {
                return dateFromStringSameOrBeforeNowConstraint(date);
            },
            showExtendDeadlineModal(exemption) {
                window.scrollTo({ top: 0, left: 0, behaviour: 'smooth' });
                this.extendModal.chosenExemption = exemption;
                this.extendModal.showModal = true;
            },
            handleExtendSuccess(payload) {
                this.fetchExemptions();
                const sector = this.extendModal.chosenExemption?.enterprise?.sector;
                const agentOrEmployee = sector === 'public' ? 'agent' : 'employé';
                const message = payload?.sendReminderEmail
                    ? `La date limite a été repoussée et un mail a été envoyé à l'${agentOrEmployee}.`
                    : 'La date limite a été repoussée.';
                this.$swal({ title: message, ...successMessage });
            },
        },
        filters: {
            formatDate
        },
        components: {
            Header,
            Sidebar,
            Footer,
            Vuetable,
            Paginator,
            ExemptionEvaluation,
            ExemptionExtendDeadline,
        }
    }
</script>
